
const getValidInvites = (invites) => {
  if (!invites || !Array.isArray(invites) || invites.length === 0) {
    return [];
  }

  return invites
    .filter(invite => 
      invite.user_details && 
      typeof invite.user_details === 'object' &&
      invite.user_details.name &&
      invite.user_details.email
    )
    .map(invite => invite.user_details);
};

const getRoleLabel = (role) => {
  const roleMap = {
    'editor': 'Edição',
    'viewer': 'Visualização',
    'planner': 'Planejador',
    'consultor': 'Consultor',
  };
  return roleMap[role] || 'Visualização';
};

const getUsersWithPlanner = (invites, plannerData) => {
  if (!invites || !Array.isArray(invites)) {
    return plannerData ? [plannerData] : [];
  }

  const validInvites = invites
    .filter(invite => 
      invite.user_details && 
      typeof invite.user_details === 'object' &&
      invite.user_details.name &&
      invite.user_details.email
    )
    .map(invite => ({
      shareId: invite.id,
      name: invite.user_details.name,
      role: getRoleLabel(invite.user_details.role),
    }));

  if (plannerData) {
    return [plannerData, ...validInvites];
  }

  return validInvites;
};

export { getValidInvites, getRoleLabel, getUsersWithPlanner };
